import React from 'react';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';

import { useApplicationBuildContext } from '@context/ApplicationBuildContext';
import { EPage } from '@types';

import { messages } from './messages';

interface IHelmetRouteProps {
  page: EPage;
}

export const RouteHelmet: React.FC<IHelmetRouteProps> = ({ page }) => {
  const {
    settings: { domainName },
  } = useApplicationBuildContext();
  const { formatMessage } = useIntl();

  const metaMessages = messages[page];

  if (!metaMessages) {
    return null;
  }

  const title = formatMessage({ ...metaMessages.title });
  const description = formatMessage({ ...metaMessages.description });
  const keywords = formatMessage({ ...metaMessages.keywords });

  return (
    <Helmet>
      <title>
        {title} | {domainName}
      </title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="robots" content="noindex, nofollow" />
    </Helmet>
  );
};
